import { DreamBlock } from '@typedream/core';
import { TRenderElementProps } from '@udecode/plate-core';
import { ComponentType } from 'react';
import { createTElementPluginFactory } from '../../plate';
import { ELEMENT_MEDIA_EMBED } from '../../pluginKeys';
import { withDropTarget } from '../../plugins/dnd';
import { MediaEmbedElementEditor } from './components/MediaEmbedElement';

export const createMediaEmbedPlugin = createTElementPluginFactory({
  key: ELEMENT_MEDIA_EMBED,
  component: withDropTarget(MediaEmbedElementEditor as ComponentType<TRenderElementProps>),
  isVoid: true,
  options: {
    isDreamBlock: true,
    isSelectable: true,
    isResizable: {
      snapX: false,
      directions: ['s', 'w', 'e', 'sw', 'se'],
      dimensionIndicator: true,
    },
    isDraggable: true,
    isDroppable: true,
    meta: {
      img: '/canvas/images/embed.png',
      title: 'Embed',
      subtitle: 'Embed a video or any site on your page',
      keywords: ['embed', 'video', 'youtube'],
    },
    format: {
      formatType: 'block',
      blurAfterSet: true,
      turnInto: [],
      focusableWhenEmpty: false,
      insertNode: {
        type: ELEMENT_MEDIA_EMBED,
        height: 70,
        children: [{ text: '' }],
      } as DreamBlock,
      validProperties: [
        'height',
        'width',
        'width_max',
        'keep_aspect_ratio',
        'url',
        'html',
        'file',
        'mobile_hide',
        'desktop_hide',
        'connect_data',
        'margin',
      ],
      validChildrenTypes: [],
    },
  },
});
